import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { AppError } from "components/pages/appError/AppError";
import { ClientRoot } from "ClientRoot";

export interface ClientRouteProps {}

export const ClientRoute: React.FC<ClientRouteProps> = () => {
  const createAppErrorElement = () => {
    return (
      <Suspense fallback={<ft-loader></ft-loader>}>
        <AppError />
      </Suspense>
    );
  };

  return (
    <Routes>
      <Route path="/" element={createAppErrorElement()}></Route>
      <Route path="/undefined" element={createAppErrorElement()}></Route>
      <Route path=":customerKey/*" element={<ClientRoot />}></Route>
    </Routes>
  );
};
